import './base_view.js.coffee';# Added by Script 
Namespace 'Customer.Dashboard.TicketDetailsStats.Integration'

class Customer.Dashboard.TicketDetailsStats.Integration.PatagoniaView extends Customer.Dashboard.TicketDetailsStats.Integration.BaseView


  template: JST['backbone/templates/customer/ticket/detail/box/ticket_details_stats/integration/patagonia']
